import { doc, getDoc, setDoc, updateDoc, onSnapshot, increment } from 'firebase/firestore';
import { db, logAnalyticsEvent } from '../firebase.js';

function escapeHtml(str) {
  if (!str) return '';
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export const POLL_CANDIDATES = [
  { id: 'candidate_1', horseName: 'UPAMECANO', jockey: 'G.KOCAKAYA', owner: '', seedVotes: 0 },
  { id: 'candidate_2', horseName: 'MUCHO BUENO', jockey: 'V.ABİŞ', owner: '', seedVotes: 0 },
  { id: 'candidate_3', horseName: 'BAY NALÇAKAN', jockey: 'H.KARATAŞ', owner: '', seedVotes: 0 },
  { id: 'candidate_4', horseName: 'BALLAD KING', jockey: 'A.SÖZEN', owner: '', seedVotes: 0 },
  { id: 'candidate_5', horseName: 'WHIZBANG', jockey: 'S.BOYRAZ', owner: '', seedVotes: 0 },
  { id: 'candidate_6', horseName: 'METAL HEART', jockey: 'M.A.SOLMAZ', owner: '', seedVotes: 0 },
  { id: 'candidate_7', horseName: 'RABOVO', jockey: 'A.ÇELİK', owner: '', seedVotes: 0 },
  { id: 'candidate_8', horseName: 'SILENT TREATMENT', jockey: 'M.AKYAVUZ', owner: '', seedVotes: 0 },
  { id: 'candidate_9', horseName: 'BRANDO', jockey: 'E.ÇİZİK', owner: '', seedVotes: 0 },
  { id: 'candidate_10', horseName: 'NEURO MATH', jockey: 'M.KAYA', owner: '', seedVotes: 0 },
  { id: 'candidate_11', horseName: 'MANDRAKE', jockey: 'MÜS.ÇELİK', owner: '', seedVotes: 0 },
  { id: 'candidate_12', horseName: 'ERSELE BEYİ', jockey: 'E.ÇANKAYA', owner: '', seedVotes: 0 },
  { id: 'candidate_13', horseName: 'THE REAL ONE', jockey: 'M.S.ÇELİK', owner: '', seedVotes: 0 },
  { id: 'candidate_14', horseName: 'GOLDRAKHAN', jockey: 'M.M.BİLGİN', owner: '', seedVotes: 0 },
  { id: 'candidate_15', horseName: 'KRALIN DANSI', jockey: 'H.ÇİZİK', owner: '', seedVotes: 0 },
  { id: 'candidate_16', horseName: 'JAEHAERA', jockey: 'A.YILDIZ', owner: '', seedVotes: 0 },
  { id: 'candidate_17', horseName: 'ALMIGHTY ESPRIT', jockey: 'SAL.ÇELİK', owner: '', seedVotes: 0 },
  { id: 'candidate_18', horseName: 'JOYFUL FOREVER', jockey: 'S.KAYA', owner: '', seedVotes: 0 },
  { id: 'candidate_19', horseName: 'MASSIMO SUPREMO', jockey: 'E.AKTUĞ', owner: '', seedVotes: 0 },
  { id: 'candidate_20', horseName: 'ANSHBA', jockey: 'A.KURŞUN', owner: '', seedVotes: 0 },
  { id: 'candidate_21', horseName: 'AIMUS LIBERATUS', jockey: 'Ö.YILDIRIM', owner: '', seedVotes: 0 },
  { id: 'candidate_22', horseName: 'JAZZ RUNNER', jockey: 'F.R.BEBEK', owner: '', seedVotes: 0 }
];

let pollSelectedCandidateId = null;
let pollUnsubscribe = null;
let latestPollData = null;
let pollActive = false;
let gazi2026Run = true;

export function getPollSelectedCandidateId() { return pollSelectedCandidateId; }
export function setPollSelectedCandidateId(val) { pollSelectedCandidateId = val; }
export function getLatestPollData() { return latestPollData; }
export function isPollActive() { return pollActive; }
export function setPollActive(val) { pollActive = val; }
export function isGazi2026Run() { return gazi2026Run; }
export function setGazi2026Run(val) { gazi2026Run = val; }

export function unsubscribePoll() {
  if (pollUnsubscribe) {
    pollUnsubscribe();
    pollUnsubscribe = null;
  }
}

// Firestore'dan 2026 anketinin aktiflik durumunu yükleyen ve tohumlayan fonksiyon
export async function initPollActiveState(gaziWinners, applyFilters) {
  try {
    const pollRef = doc(db, 'polls', '2026_gazi');
    const docSnap = await getDoc(pollRef);
    let pollData = {};
    if (!docSnap.exists()) {
      // Seeding: Create document with active: false, options, and votes map if missing
      const initialOptions = POLL_CANDIDATES.map(c => ({
        id: c.id,
        horseName: c.horseName,
        jockey: c.jockey,
        owner: c.owner
      }));
      const initialVotes = {};
      POLL_CANDIDATES.forEach(c => {
        initialVotes[c.id] = c.seedVotes;
      });

      const seedData = {
        active: false,
        options: initialOptions,
        votes: initialVotes
      };
      await setDoc(pollRef, seedData);
      pollData = seedData;
    } else {
      pollData = docSnap.data();
    }
    
    pollActive = pollData.active === true;
    latestPollData = pollData;
    
    if (pollData.winner && pollData.winner.horseName) {
      gazi2026Run = true;
      const w2026 = gaziWinners.find(w => w.year === 2026);
      if (w2026) {
        w2026.horseName = pollData.winner.horseName;
        w2026.horseNameUpper = pollData.winner.horseName.toUpperCase();
        w2026.jockey = pollData.winner.jockey;
        w2026.owner = pollData.winner.owner;
        w2026.time = pollData.winner.time;
        w2026.video = pollData.winner.video || null;
        w2026.story = pollData.winner.story || w2026.story;
        w2026.story_en = pollData.winner.story_en || w2026.story_en;
      }
    }

    applyFilters();
  } catch (err) {
    console.error("Error initializing poll active state:", err);
  }
}

// 2026 Tahmin Anketi Çizim ve Etkileşim Mantığı
export function renderPollUI(getActiveLang, showToast) {
  if (pollUnsubscribe) return; // Prevent duplicate snapshot listeners if already active

  const pollRef = doc(db, 'polls', '2026_gazi');

  // Firestore real-time listener
  pollUnsubscribe = onSnapshot(pollRef, async (docSnap) => {
    let pollData = {};
    if (!docSnap.exists()) {
      const initialOptions = POLL_CANDIDATES.map(c => ({
        id: c.id,
        horseName: c.horseName,
        jockey: c.jockey,
        owner: c.owner
      }));
      const initialVotes = {};
      POLL_CANDIDATES.forEach(c => {
        initialVotes[c.id] = c.seedVotes;
      });

      const seedData = {
        active: false,
        options: initialOptions,
        votes: initialVotes
      };
      
      try {
        await setDoc(pollRef, seedData);
        pollData = seedData;
      } catch (err) {
        console.error("Firestore seeding error:", err);
      }
    } else {
      pollData = docSnap.data();
    }
    
    // Save to local state
    latestPollData = pollData;
    
    // Draw UI dynamically
    updatePollUIWithData(pollData, getActiveLang, showToast);
  }, (error) => {
    console.error("Firestore listener error:", error);
  });
}

// Firestore verilerine göre anket arayüzünü güncelleyen yardımcı fonksiyon
function updatePollUIWithData(pollData, getActiveLang, showToast) {
  const pollContainer = document.getElementById('poll-modal-content');
  if (!pollContainer) return;

  const activeLang = getActiveLang();
  const votedCandidateId = localStorage.getItem('gazi_vote_2026');
  const hasVoted = !!votedCandidateId;
  const showResults = hasVoted || gazi2026Run;

  const optionsList = pollData.options || POLL_CANDIDATES;
  const votesMap = pollData.votes || {};

  // Toplam oyları hesaplama
  let totalVotes = 0;
  optionsList.forEach(c => {
    totalVotes += (votesMap[c.id] || 0);
  });

  if (showResults) {
    // Sonuç Ekranı HTML
    const candidatesHtml = optionsList.map(c => {
      const votes = votesMap[c.id] || 0;
      const pct = totalVotes > 0 ? Math.round((votes / totalVotes) * 100) : 0;
      const isUserChoice = votedCandidateId === c.id;

      let metaHtml = '';
      if (c.jockey && c.jockey.trim() !== '') {
        metaHtml += `<span class="poll-meta-jockey">${escapeHtml(c.jockey)}</span>`;
      }
      if (c.owner && c.owner.trim() !== '') {
        const label = activeLang === 'en' ? 'Owner' : 'Sahip';
        if (metaHtml) {
          metaHtml += `<span class="poll-meta-separator"> | </span>`;
        }
        metaHtml += `<span class="poll-meta-owner">${label}: ${escapeHtml(c.owner)}</span>`;
      }

      const votesText = activeLang === 'en' 
        ? `${votes} ${votes === 1 ? 'Vote' : 'Votes'}` 
        : `${votes} Oy`;
      const pctText = activeLang === 'en' ? `${pct}%` : `%${pct}`;

      return `
        <div class="poll-option ${isUserChoice ? 'selected' : ''}" style="cursor: default;">
          <div class="poll-progress-bg" style="width: ${pct}%;" data-pct="${pct}"></div>
          <div class="poll-option-left">
            <div class="poll-option-details">
              <span class="poll-horse-name">${escapeHtml(c.horseName)}</span>
              ${metaHtml ? `<span class="poll-meta-text">${metaHtml}</span>` : ''}
            </div>
          </div>
          <div style="z-index: 2; text-align: right;">
            <div class="poll-percentage">${pctText}</div>
            <div class="poll-votes-count">${votesText}</div>
          </div>
        </div>
      `;
    }).join('');

    const isSubscribed = localStorage.getItem('gazi_newsletter_subscribed') === 'true';
    let newsletterHtml = '';
    if (!gazi2026Run) {
      if (isSubscribed) {
        newsletterHtml = `
          <div class="poll-newsletter-box success" id="poll-newsletter-container">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#2ecc71" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            <p>${activeLang === 'en' ? 'You have subscribed to race results!' : 'Koşu sonuçları aboneliğiniz oluşturuldu!'}</p>
          </div>
        `;
      } else {
        newsletterHtml = `
          <div class="poll-newsletter-box" id="poll-newsletter-container">
            <div class="newsletter-header">
              <h4>${activeLang === 'en' ? 'Get Results by E-mail' : 'Sonuçları E-posta ile Alın'}</h4>
              <p>${activeLang === 'en' ? 'Get the 2026 champion and race results in your inbox immediately after the race.' : 'Koşu biter bitmez 2026 şampiyonunu ve derece sonuçlarını e-posta ile alın.'}</p>
            </div>
            <div class="newsletter-form-row">
              <input type="email" id="newsletter-email-input" placeholder="${activeLang === 'en' ? 'Your e-mail address...' : 'E-posta adresiniz...'}" required />
              <button class="btn-newsletter-submit" id="btn-newsletter-subscribe">
                ${activeLang === 'en' ? 'Subscribe' : 'Abone Ol'}
              </button>
            </div>
            <div class="newsletter-consent-row">
              <label class="newsletter-checkbox-label">
                <input type="checkbox" id="newsletter-consent-check" required />
                <span>
                  ${activeLang === 'en' 
                    ? 'I consent to receiving race results and updates. I have read the <a href="#" id="link-privacy-policy" style="color: var(--color-gold-light); text-decoration: underline; font-weight: 500;">Privacy Policy</a>.' 
                    : 'Koşu sonuçları ve güncellemeler hakkında e-posta almayı kabul ediyorum. <a href="#" id="link-kvkk-notice" style="color: var(--color-gold-light); text-decoration: underline; font-weight: 500;">KVKK Aydınlatma Metni</a>\'ni okudum.'}
                </span>
              </label>
            </div>
          </div>
        `;
      }
    }

    pollContainer.innerHTML = `
      <div class="poll-container">
        <div class="poll-header">
          ${gazi2026Run ? `
          <span class="poll-voted-badge" style="background: rgba(46, 204, 113, 0.15); color: #2ecc71;">
            <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><polyline points="20 6 9 17 4 12"></polyline></svg>
            ${activeLang === 'en' ? 'Poll Closed' : 'Anket Sonlandı'}
          </span>
          ` : (hasVoted ? `
          <span class="poll-voted-badge">
            <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px;"><polyline points="20 6 9 17 4 12"></polyline></svg>
            ${activeLang === 'en' ? 'Prediction Saved' : 'Tahmininiz Kaydedildi'}
          </span>
          ` : '')}
          <h3 class="poll-title">${activeLang === 'en' ? '2026 Gazi Derby Predictions' : '2026 Gazi Koşusu Tahminleri'}</h3>
          <p class="poll-subtitle">${gazi2026Run 
            ? (activeLang === 'en' ? 'Final prediction rates by community participation' : 'Kullanıcıların katılımıyla oluşan final şampiyonluk tahmini oranları')
            : (activeLang === 'en' ? 'Live prediction rates by community participation' : 'Kullanıcıların katılımıyla güncel şampiyonluk tahmini oranları')}</p>
        </div>
        <div class="poll-options-list">
          ${candidatesHtml}
        </div>
        ${newsletterHtml}
        <div class="poll-actions-footer" style="${(isSubscribed || gazi2026Run) ? 'display: none;' : ''}">
          <button class="btn-poll-link" id="btn-poll-change-vote">${activeLang === 'en' ? 'Change My Prediction' : 'Tahminimi Değiştir'}</button>
        </div>
      </div>
    `;

    // KVKK / Privacy Policy Link Event Listeners
    const linkKvkk = document.getElementById('link-kvkk-notice');
    if (linkKvkk) {
      linkKvkk.addEventListener('click', (e) => {
        e.preventDefault();
        showKvkkModal(activeLang);
      });
    }
    const linkPrivacy = document.getElementById('link-privacy-policy');
    if (linkPrivacy) {
      linkPrivacy.addEventListener('click', (e) => {
        e.preventDefault();
        showKvkkModal(activeLang);
      });
    }

    // Animating progress bars
    const bars = pollContainer.querySelectorAll('.poll-progress-bg');
    bars.forEach(bar => {
      const pct = bar.getAttribute('data-pct');
      bar.style.width = '0%';
      requestAnimationFrame(() => {
        bar.style.width = `${pct}%`;
      });
    });

    // E-mail subscription action
    const btnSubscribe = document.getElementById('btn-newsletter-subscribe');
    if (btnSubscribe) {
      btnSubscribe.addEventListener('click', async () => {
        const emailInput = document.getElementById('newsletter-email-input');
        const consentCheck = document.getElementById('newsletter-consent-check');
        if (!emailInput) return;

        const email = emailInput.value.trim();
        if (email === '') {
          showToast(activeLang === 'en' ? 'Please enter a valid e-mail address.' : 'Lütfen geçerli bir e-posta adresi girin.');
          return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          showToast(activeLang === 'en' ? 'Please enter a valid e-mail address.' : 'Lütfen geçerli bir e-posta adresi girin.');
          return;
        }

        if (consentCheck && !consentCheck.checked) {
          showToast(activeLang === 'en' ? 'You must accept the communication consent.' : 'E-posta bilgilendirme onayını kabul etmelisiniz.');
          return;
        }

        btnSubscribe.setAttribute('disabled', 'true');
        btnSubscribe.textContent = '...';

        try {
          const votedCandidateId = localStorage.getItem('gazi_vote_2026') || null;
          let votedHorseName = '';
          if (votedCandidateId && latestPollData && latestPollData.options) {
            const candidate = latestPollData.options.find(o => o.id === votedCandidateId);
            if (candidate) {
              votedHorseName = candidate.horseName;
            }
          }

          const subRef = doc(db, 'subscribers', email);
          const subscriberData = {
            email: email,
            subscribedAt: new Date().toISOString(),
            language: activeLang
          };
          if (votedCandidateId) {
            subscriberData.votedCandidateId = votedCandidateId;
          }
          if (votedHorseName) {
            subscriberData.votedHorseName = votedHorseName;
          }

          await setDoc(subRef, subscriberData);
          logAnalyticsEvent('newsletter_signup');

          localStorage.setItem('gazi_newsletter_subscribed', 'true');
          
          const newsContainer = document.getElementById('poll-newsletter-container');
          if (newsContainer) {
            newsContainer.classList.add('success');
            newsContainer.innerHTML = `
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#2ecc71" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
              <p>${activeLang === 'en' ? 'You have subscribed to race results!' : 'Koşu sonuçları aboneliğiniz oluşturuldu!'}</p>
            `;
          }

          // Hide change prediction button immediately
          const btnChangeVote = document.getElementById('btn-poll-change-vote');
          if (btnChangeVote) {
            btnChangeVote.parentElement.style.display = 'none';
          }

          showToast(activeLang === 'en' ? 'Subscription successful!' : 'Aboneliğiniz başarıyla tamamlandı!');
        } catch (err) {
          console.error("Newsletter subscription error:", err);
          btnSubscribe.removeAttribute('disabled');
          btnSubscribe.textContent = activeLang === 'en' ? 'Subscribe' : 'Abone Ol';
          showToast(activeLang === 'en' ? 'An error occurred during subscription.' : 'Abonelik sırasında bir hata oluştu.');
        }
      });
    }

    // Change prediction action
    const btnChangeVote = document.getElementById('btn-poll-change-vote');
    if (btnChangeVote) {
      btnChangeVote.addEventListener('click', async () => {
        if (votedCandidateId) {
          btnChangeVote.setAttribute('disabled', 'true');
          btnChangeVote.textContent = activeLang === 'en' ? 'UPDATING...' : 'GÜNCELLENİYOR...';

          try {
            localStorage.removeItem('gazi_vote_2026');
            pollSelectedCandidateId = null;
            if (latestPollData) {
              const localPollData = JSON.parse(JSON.stringify(latestPollData));
              if (localPollData.votes && localPollData.votes[votedCandidateId]) {
                localPollData.votes[votedCandidateId] = Math.max(0, localPollData.votes[votedCandidateId] - 1);
              }
              updatePollUIWithData(localPollData, getActiveLang, showToast);
            }

            const pollRef = doc(db, 'polls', '2026_gazi');
            await updateDoc(pollRef, {
              [`votes.${votedCandidateId}`]: increment(-1)
            });
          } catch (err) {
            console.error("Firestore vote reset error:", err);
            localStorage.setItem('gazi_vote_2026', votedCandidateId);
            if (latestPollData) {
              updatePollUIWithData(latestPollData, getActiveLang, showToast);
            }
            const toastMsg = activeLang === 'en'
              ? 'An error occurred while updating the prediction.'
              : 'Tahmin güncellenirken bir hata oluştu.';
            showToast(toastMsg);
          }
        }
      });
    }

  } else {
    // Oy Verme Ekranı HTML
    const candidatesHtml = optionsList.map(c => {
      const isSelected = pollSelectedCandidateId === c.id;

      let metaHtml = '';
      if (c.jockey && c.jockey.trim() !== '') {
        metaHtml += `<span class="poll-meta-jockey">${escapeHtml(c.jockey)}</span>`;
      }
      if (c.owner && c.owner.trim() !== '') {
        const label = activeLang === 'en' ? 'Owner' : 'Sahip';
        if (metaHtml) {
          metaHtml += `<span class="poll-meta-separator"> | </span>`;
        }
        metaHtml += `<span class="poll-meta-owner">${label}: ${escapeHtml(c.owner)}</span>`;
      }

      return `
        <div class="poll-option ${isSelected ? 'selected' : ''}" data-candidate-id="${c.id}">
          <div class="poll-option-left">
            <div class="poll-radio">
              <div class="poll-radio-inner"></div>
            </div>
            <div class="poll-option-details">
              <span class="poll-horse-name">${escapeHtml(c.horseName)}</span>
              ${metaHtml ? `<span class="poll-meta-text">${metaHtml}</span>` : ''}
            </div>
          </div>
        </div>
      `;
    }).join('');

    pollContainer.innerHTML = `
      <div class="poll-container">
        <div class="poll-header">
          <h3 class="poll-title">${activeLang === 'en' ? 'Who Will Win the 100th Gazi Derby?' : '100. Gazi Koşusu Şampiyonu Kim Olur?'}</h3>
          <p class="poll-subtitle">${activeLang === 'en' ? 'The 2026 race has not been run yet. Select one of the candidates and cast your vote.' : '2026 yılı yarışı henüz koşulmadı. Adaylardan birini seçerek oyunuzu verin.'}</p>
        </div>
        <div class="poll-options-list" id="poll-voting-options">
          ${candidatesHtml}
        </div>
        <button class="btn-poll-vote" id="btn-poll-submit-vote" ${!pollSelectedCandidateId ? 'disabled' : ''}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          ${activeLang === 'en' ? 'SUBMIT VOTE' : 'OY VER'}
        </button>
      </div>
    `;

    // Click listeners on candidate options
    const options = pollContainer.querySelectorAll('#poll-voting-options .poll-option');
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        pollSelectedCandidateId = opt.getAttribute('data-candidate-id');
        
        options.forEach(o => o.classList.remove('selected'));
        opt.classList.add('selected');
        
        const btnSubmit = document.getElementById('btn-poll-submit-vote');
        if (btnSubmit) btnSubmit.removeAttribute('disabled');
      });
    });

    // Submitting vote
    const btnSubmit = document.getElementById('btn-poll-submit-vote');
    if (btnSubmit) {
      btnSubmit.addEventListener('click', async () => {
        if (pollSelectedCandidateId) {
          btnSubmit.setAttribute('disabled', 'true');
          btnSubmit.innerHTML = activeLang === 'en' ? 'SUBMITTING...' : 'GÖNDERİLİYOR...';
          
          const selectedId = pollSelectedCandidateId;
          try {
            localStorage.setItem('gazi_vote_2026', selectedId);

            const candidate = POLL_CANDIDATES.find(c => c.id === selectedId);
            logAnalyticsEvent('poll_vote', {
              candidate_id: selectedId,
              horse_name: candidate ? candidate.horseName : ''
            });

            if (latestPollData) {
              const localPollData = JSON.parse(JSON.stringify(latestPollData));
              if (localPollData.votes) {
                localPollData.votes[selectedId] = (localPollData.votes[selectedId] || 0) + 1;
              }
              updatePollUIWithData(localPollData, getActiveLang, showToast);
            }

            const pollRef = doc(db, 'polls', '2026_gazi');
            await updateDoc(pollRef, {
              [`votes.${selectedId}`]: increment(1)
            });
          } catch (err) {
            console.error("Firestore voting error:", err);
            localStorage.removeItem('gazi_vote_2026');
            if (latestPollData) {
              updatePollUIWithData(latestPollData, getActiveLang, showToast);
            }
            const toastMsg = activeLang === 'en'
              ? 'An error occurred while voting.'
              : 'Oy verilirken bir hata oluştu.';
            showToast(toastMsg);
          }
        }
      });
    }
  }
}

// Modal and Close Actions Setup
export function initPollModal(getActiveLang, showToast) {
  const btnJoinPoll = document.getElementById('btn-join-poll');
  const btnShowPollResults = document.getElementById('btn-show-poll-results');
  const pollModal = document.getElementById('poll-modal');
  const pollModalCloseBtn = document.getElementById('poll-modal-close-btn');

  if (btnJoinPoll && pollModal) {
    btnJoinPoll.addEventListener('click', () => {
      pollModal.style.display = 'flex';
      renderPollUI(getActiveLang, showToast);
      logAnalyticsEvent('poll_join');
    });
  }

  if (btnShowPollResults && pollModal) {
    btnShowPollResults.addEventListener('click', () => {
      pollModal.style.display = 'flex';
      renderPollUI(getActiveLang, showToast);
      logAnalyticsEvent('poll_view_results');
    });
  }

  const closeHandler = () => {
    if (pollModal) pollModal.style.display = 'none';
    unsubscribePoll();
  };

  if (pollModalCloseBtn) {
    pollModalCloseBtn.addEventListener('click', closeHandler);
  }

  if (pollModal) {
    pollModal.addEventListener('click', (e) => {
      if (e.target === pollModal) {
        closeHandler();
      }
    });
  }
}

function showKvkkModal(lang) {
  let modal = document.getElementById('kvkk-privacy-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'kvkk-privacy-modal';
    modal.className = 'kvkk-modal-overlay';
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(3, 7, 5, 0.9);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 21000;
    `;
    
    modal.innerHTML = `
      <div class="kvkk-modal-container" style="position: relative; width: 90%; max-width: 600px; max-height: 80vh; background: rgba(6, 14, 10, 0.95); border: 1px solid rgba(212, 175, 55, 0.3); border-radius: 12px; padding: 30px; display: flex; flex-direction: column; overflow: hidden; box-shadow: 0 0 50px rgba(212, 175, 55, 0.15);">
        <button class="kvkk-modal-close" style="position: absolute; top: 16px; right: 18px; background: none; border: none; color: var(--color-text-secondary); font-size: 28px; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; z-index: 10;" title="${lang === 'en' ? 'Close' : 'Kapat'}">&times;</button>
        <h3 style="font-family: var(--font-display); font-size: 20px; font-weight: 800; color: var(--color-gold-light); margin-top: 0; margin-bottom: 15px; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 10px;">
          ${lang === 'en' ? 'Privacy Policy & Information Text' : 'KVKK Aydınlatma Metni'}
        </h3>
        <div class="kvkk-modal-body" style="flex: 1; overflow-y: auto; font-size: 13.5px; line-height: 1.6; color: var(--color-text-secondary); padding-right: 6px;">
          ${lang === 'en' ? getPrivacyTextEn() : getKvkkTextTr()}
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    
    // Close events
    const closeBtn = modal.querySelector('.kvkk-modal-close');
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  } else {
    modal.querySelector('h3').textContent = lang === 'en' ? 'Privacy Policy & Information Text' : 'KVKK Aydınlatma Metni';
    modal.querySelector('.kvkk-modal-body').innerHTML = lang === 'en' ? getPrivacyTextEn() : getKvkkTextTr();
    modal.style.display = 'flex';
  }
}

function getKvkkTextTr() {
  return `
    <p><strong>Veri Sorumlusu:</strong> gaziderby.com</p>
    <p>6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) uyarınca, e-posta adresiniz ("kişisel veriniz"), gaziderby.com tarafından aşağıdaki esaslar çerçevesinde işlenecektir:</p>
    <p><strong>1. Kişisel Verilerin Hangi Amaçla İşleneceği:</strong><br>
    Toplanan e-posta adresiniz, yalnızca 2026 yılı Gazi Koşusu sonuçları, şampiyonluk haberleri, derece bilgileri ve platformumuzla ilgili güncellemelerin tarafınıza e-posta yoluyla ulaştırılması (bülten gönderimi) amacıyla işlenecektir.</p>
    <p><strong>2. İşlenen Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği:</strong><br>
    Kişisel verileriniz, herhangi bir üçüncü tarafa veya kuruma reklam/pazarlama amacıyla aktarılmamakta olup, yalnızca altyapı hizmeti sağlayıcılarımız (örneğin Firebase) bünyesinde güvenli şekilde saklanmaktadır.</p>
    <p><strong>3. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi:</strong><br>
    E-posta adresiniz, web sitemiz üzerinden rızanızla doldurduğunuz form aracılığıyla tamamen elektronik ortamda toplanmaktadır. İşlemenin hukuki sebebi, KVKK Madde 5/1 uyarınca gösterdiğiniz "Açık Rıza"dır.</p>
    <p><strong>4. Veri Sahibinin Hakları:</strong><br>
    Dilediğiniz zaman açık rızanızı geri çekerek bülten aboneliğinden ayrılabilirsiniz. KVKK Madde 11 kapsamındaki haklarınız (bilgi alma, düzeltme, silme talebi vb.) için bizimle iletişime geçebilirsiniz.</p>
  `;
}

function getPrivacyTextEn() {
  return `
    <p><strong>Data Controller:</strong> gaziderby.com</p>
    <p>In accordance with data protection regulations, your e-mail address ("personal data") will be processed by gaziderby.com under the following conditions:</p>
    <p><strong>1. Purpose of Processing:</strong><br>
    Your collected e-mail address will be processed solely to deliver the 2026 Gazi Derby race results, championship news, timing results, and updates related to our platform directly to your inbox.</p>
    <p><strong>2. Data Transfers:</strong><br>
    Your personal data is not shared with or transferred to any third party for commercial or marketing purposes. It is securely stored using our backend service provider (Firebase).</p>
    <p><strong>3. Legal Basis and Methods:</strong><br>
    Your e-mail is collected electronically through the voluntary subscription form on our website. The processing is based on your explicit "Consent".</p>
    <p><strong>4. Your Rights:</strong><br>
    You can withdraw your consent and unsubscribe from the newsletter at any time. For your rights regarding access, rectification, or deletion of your personal data, you may contact us.</p>
  `;
}
